import { ChangeEvent } from 'react';
import Grid from '@mui/material/Grid';
import Signature from '../../../../signature/signature';
import { SignatureDetailsProps } from '../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/parkinglistTypes';
import CustomTextField from '../../../../CustomTextInput';

const SignatureDetails = ({
    errors,
    payload,
    setSignatureUrlBase64,
    updateField,
    signatureUrlBase64
}: SignatureDetailsProps) => {
    return (
        <Grid container>
            <Grid item xs={12} md={12} lg={6}>
                <div className='lg:border lg:border-appcolorgreyfaint lg:px-[1rem]  lg:pt-4 lg:pb-0 h-full'>
                    <Grid
                        container
                        spacing={0}
                        sx={{
                            marginTop: '0px'
                        }}
                    >
                        <Grid item xs={12} md={12} lg={12}>
                            <CustomTextField
                                error={errors?.placeOfIssue.length > 0}
                                helperText={
                                    errors?.placeOfIssue.length > 0
                                        ? errors?.placeOfIssue
                                        : undefined
                                }
                                required
                                id='commercialinvoice-placeOfIssue'
                                label='Place of Issue'
                                name='placeOfIssue'
                                value={payload?.placeOfIssue}
                                onChange={(
                                    e: ChangeEvent<HTMLInputElement>
                                ) => {
                                    updateField('placeOfIssue', e.target.value);
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} md={12} lg={12}>
                            <div className='mt-4'>
                                <CustomTextField
                                    error={errors?.signatoryCompany.length > 0}
                                    helperText={
                                        errors?.signatoryCompany.length > 0
                                            ? errors?.signatoryCompany
                                            : undefined
                                    }
                                    required
                                    id='commercialinvoice-signatoryCompany'
                                    label='Signatory Company'
                                    name='signatoryCompany'
                                    value={payload?.signatoryCompany}
                                    onChange={(
                                        e: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        updateField(
                                            'signatoryCompany',
                                            e.target.value
                                        );
                                    }}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <div className='mt-4'>
                                <CustomTextField
                                    error={
                                        errors?.nameOfAuthorisedSignatory
                                            .length > 0
                                    }
                                    helperText={
                                        errors?.nameOfAuthorisedSignatory
                                            .length > 0
                                            ? errors?.nameOfAuthorisedSignatory
                                            : undefined
                                    }
                                    required
                                    id='commercialinvoice-nameOfAuthorisedSignatory'
                                    label='Name of Authorized Signature'
                                    name='nameOfAuthorisedSignatory'
                                    value={payload?.nameOfAuthorisedSignatory}
                                    onChange={(
                                        e: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        updateField(
                                            'nameOfAuthorisedSignatory',
                                            e.target.value
                                        );
                                    }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
                <div className='w-full mt-4 lg:mt-[-10px]'>
                    <Signature
                        name='signatureUrl'
                        updateField={updateField}
                        setSignatureUrlBase64={setSignatureUrlBase64}
                        signatureUrlBase64={signatureUrlBase64}
                    />
                </div>
            </Grid>
        </Grid>
    );
};

export default SignatureDetails;
